import type {
  InvitationActionType,
  ApiInvitation,
  Invitation,
} from '../schemas/invitation.schema';
import type { BaseApiResponse } from './types/api.types';

import { get, put } from './axios';

export async function fetchInvitation() {
  const response = await get<BaseApiResponse<Invitation>>(
    `/v2/invitation/current`,
  );

  return response?.data;
}

export async function updateInvitation(
  organizationUserId: string,
  type: InvitationActionType,
  touVersionId?: string,
  connectionTouVersionId?: string,
) {
  const response = await put<ApiInvitation>(
    `/v2/invitation/update-invite/${organizationUserId}`,
    { touVersionId, connectionTouVersionId, type },
  );

  return response?.data ?? null;
}
